<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :total-rows="total"
      :sort-options="{ enabled: true }"
      :pagination-options="{ enabled: true }"
      style-class="vgt-table border-0 table-auto"
      @on-sort-change="$emit('sort-change', $event)"
      @on-page-change="$emit('page-change', $event)"
      @on-per-page-change="$emit('per-page-change', $event)"
      @on-selected-rows-change="$emit('select-change', $event)"
      styleClass="vgt-table condensed"
    >
      <div slot="emptystate" class="text-center font-size-14">No data available</div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'" class="d-flex gap-3 justify-content-center align-items-center">
          <b-button class="no-wrap btn-pill" variant="info" size="sm" title="View" @click="$emit('view-detail', props.row)">
            <span class="fe fe-eye"></span>
          </b-button>
        </span>

        <span v-if="props.column.field === 'status'">
          <div class="d-flex flex-row align-items-center justify-content-start" @click="$emit('change-status', props.row)">
            <span :class="getTrainingStatusClass(props.row.status)">
              {{ formatCertificateStatus(props.row.status) }}
            </span>
          </div>
        </span>

        <span v-else-if="props.column.field === 'feedback'" class="d-flex align-items-center justify-content-start">
          <span v-if="props.row.feedback" class="text-dark">{{ props.row.feedback }}</span>
          <span v-else class="text-muted">-</span>
        </span>

        <span v-else class="d-flex align-items-center justify-content-start">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between align-items-center mt-3 px-3">
          <div class="text-muted">
            Showing
            <strong>{{ showingFrom }} - {{ showingTo }}</strong>
            of <strong>{{ total }}</strong> items
          </div>

          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="pageSize"
            first-number
            last-number
            align="right"
            size="md"
            @change="$emit('page-change-from-bv', $event)"
          />
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { props } from "vue2-dropzone";
import { getTrainingStatusClass, snakeToTitle } from "../utils/utils";
import { formatCurrency } from "@/utils/formatCurrency";

export default {
  name: "CertificateReviewTable",
  props: {
    rows: Array,
    total: Number,
    showingFrom: Number,
    showingTo: Number,
    page: Number,
    pageSize: Number,
  },

  computed: {},

  data() {
    return {
      columns: [
        {
          label: "Employee Name",
          field: "employee_name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Training",
          field: "training.title",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Competency",
          field: "competency.name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Platform",
          field: "training.platform",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Method",
          field: "training.method.name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Type",
          field: "training.type.name",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Revision Note",
          field: "feedback",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
      ],
    };
  },

  methods: {
    getTrainingStatusClass,
    snakeToTitle,
    formatCurrency,
    formatCertificateStatus(status) {
      const labels = {
        in_review: "Pending",
        revision: "Revisi Note",
        completed: "Approved",
      };

      return labels[status] || this.snakeToTitle(status);
    },
  },
};
</script>

<style scoped>
.w-action {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

.vgt-table.table-auto table {
  table-layout: auto !important;
}

:deep(.custom-switch .custom-control-label) {
  display: flex !important;
  align-items: center !important;
  cursor: pointer;
}

:deep(.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label::before) {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}

:deep(.custom-switch .custom-control-input:checked ~ .custom-control-label::before) {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

:deep(.custom-switch .custom-control-input:checked ~ .custom-control-label::after) {
  background-color: #fff !important;
}

:deep(.table-header) {
  font-size: 12px !important;
}

:deep(.vgt-table td, .vgt-table th) {
  font-size: 12px !important;
}
</style>
